import React from "react";
import { Container, Row, Col, Button} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";
import "../styles/index.css";

const SignUp = () => (
  <>
    <script
      src="https://kit.fontawesome.com/a17da011a4.js"
      crossorigin="anonymous"
    ></script>
    <div className="sign-up-nav">
      <Navigation></Navigation>
      <div className="header-text">
        <Container>
          <Row>
            <p className="heading-about">JOINING PFC</p>
          </Row>
        </Container>
      </div>
    </div>
    <br />
    <div>
      <Container className="fencing-body">
        <h1>
          The next beginner's practice session is: September 8rd, 9:00pm in MP5 in the COREC.
        </h1>
        <br />
        <hr></hr>
          <br />
          <h2>Pre-Practice Item 1: Sign the Waiver</h2>
          <p className="fencing-text">
            Before you can start fencing, you need to sign our safety waiver.
            Fencing isn't dangerous, but it is a contact sport!
          </p>

          <a href="https://club.fusionfamily.com/@/purdueclubsports/6434436c-d181-40f2-b455-273a7344db2b">
            <Button variant="dark">Safety Waiver</Button>
          </a>
            
          <a href="https://powerforms.docusign.net/99f87433-9769-472c-882d-231571058091?env=na2&accountId=9ad6adfd-6804-409b-91bc-173cbee909f9">
            <Button variant="dark">Waiver for Minors</Button>
          </a>
          <p> (You may need to sign the waiver for minors at the COREC front desk with your parent, if the link doesn't work.) </p>
        <br />
        <hr></hr>
          <br />
          <h2>Pre-Practice Item 2: Wear appropriate clothing!</h2>
          <p className="fencing-text">
            Make sure you wear gym shoes and breathable/athletic clothing to practice.
          </p>
          <br />
      {/* theres no link to a resource page...
        <hr></hr>
        <br />
          <h2>
            (Optional) Pre-Practice Item 3: Skim the
            <a href="/beginner"> Beginner </a> Resource Page
          </h2>
          <p className="fencing-text">
            This page has some info on the basics of fencing that will give you
            a head start before practice. If you can't read it though, don't
            worry, we'll cover everything at practice.
          </p>
          <br />
        <hr></hr>
        */}
        <h2>
          If you've signed the waiver and wear right clothes, you're
          ready to go! Just meet us at the Corec, and we've got the rest.
          Welcome to fencing at Purdue!
        </h2>
      </Container>
      <br />
      <br />
    </div>
    <Footer></Footer>
  </>
);

export default SignUp;
